import React, { useState, useEffect } from 'react';
import { Panel } from "@jpmuitk/panel";
import PrivacyAgreementContainer from "./PrivacyAgreementContainer";
import ValidationContainer from "./ValidationContainer";
import { getProfileConfiguration } from '../../redux/clientActions';
import Banner from '../Banner';
import { ColumnLayout } from '@jpmuitk/column-layout';

const styles = {
  root: {
    background: '#F2F4F6',
    height: '100%',
    margin: '0 auto',
    overflow: 'auto',
  },
  panel: {
    flex: 1,
    overflow: 'auto',
  },
  mainContent: {
    flex: 1,
    width: '100%',
    height: '100%',
    margin: '0 auto',
    overflow: 'auto',
  },
  columnPanel: {
    textAlign: 'center',
    paddingTop: '5rem',
    paddingBottom: '5rem',
  },
};

export default function DocFlow({ accessToken, sessionToken }) {
  const [profileConfiguration, setProfileConfiguration] = useState();
  const [isAgreementOpen, setIsAgreementOpen] = useState(false);
  const [isVerificationOpen, setIsVerificationOpen] = useState(false);
  const [userConsent, setUserConsent] = useState();
  const [countries, setCountries] = useState([]);
  const [accountResponse, setAccountResponse] = useState();

  useEffect(() => {
    const initDocFlow = async () => {
      try {
        const response = await getProfileConfiguration(accessToken, sessionToken);
        const profileConfiguration = await response.json();
        setProfileConfiguration(profileConfiguration);
        setIsAgreementOpen(true);

        if (profileConfiguration && profileConfiguration.docTypeByCountry) {
          const countryList = profileConfiguration.docTypeByCountry
            .map((docTypeByCountry) => docTypeByCountry.country.countryName);
          setCountries(countryList);
        }
      } catch (error) {
        console.error(error);
      }
    };

    initDocFlow();
  }, [accessToken, sessionToken]);

  return (
    <ColumnLayout container style={styles.root} direction="column">
      <ColumnLayout item>
        <Banner profileConfiguration={profileConfiguration} accessToken={accessToken} sessionToken={sessionToken} />
        <Panel>
          {isAgreementOpen && !isVerificationOpen && (
            <PrivacyAgreementContainer
              profileConfiguration={profileConfiguration}
              setIsAgreementOpen={setIsAgreementOpen}
              setIsVerificationOpen={setIsVerificationOpen}
              setUserConsent={setUserConsent}
              accessToken={accessToken}
              sessionToken={sessionToken}
            />
          )}
          {!isAgreementOpen && isVerificationOpen && (
            <ValidationContainer
              profileConfiguration={profileConfiguration}
              accountResponse={accountResponse}
              setAccountResponse={setAccountResponse}
              userConsent={userConsent}
              countries={countries}
              accessToken={accessToken}
              sessionToken={sessionToken}
            />
          )}
        </Panel>

      </ColumnLayout>

    </ColumnLayout>
  );
}
